var cilLaptop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M440,368a24.028,24.028,0,0,0,24-24V104a24.028,24.028,0,0,0-24-24H72a24.028,24.028,0,0,0-24,24V344a24.028,24.028,0,0,0,24,24ZM80,112H432V336H80Z' class='ci-primary'/><rect width='480' height='32' x='16' y='400' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilLaptop };

